import React, { useEffect } from "react";
// Constants
import { REGULATORY } from "constants/Routes";
// Helpers
import { getBUFromLocalStorage } from "helpers/storage";
// Hooks
import { useEventRequest, useGetCurrentBusinessUnit } from "hooks";
// Components
import { Regulatory as RegulatoryComponents } from "components/Regulatory";
import { Header, Spacer, PageContent, PageHeader, Tabs } from "components";

export const Regulatory: React.FC = () => {
  const { eventsRequest } = useEventRequest();

  const businessUnitId = getBUFromLocalStorage();
  const { regulatorySystem } = useGetCurrentBusinessUnit();

  const regulatoryTabs = [
    {
      key: 0,
      name: regulatorySystem?.name || "",
      route: REGULATORY,
    },
  ];

  useEffect(() => {
    eventsRequest({ name: "regulatory-opened-dashboard", details: { businessUnitId } });
  }, [eventsRequest, businessUnitId]);

  return (
    <>
      <PageHeader>
        <Header title="Regulatory Dashboard" subTitle="Manage your regulatory reporting" />
        <Tabs tabs={regulatoryTabs} selectedTab={0} />
      </PageHeader>
      <PageContent>
        <Spacer baselineHeight={2} />
        <RegulatoryComponents />
      </PageContent>
    </>
  );
};

export default Regulatory;
